import type { ReactNode } from "react";

type InboxShellProps = {
  sidebar: ReactNode;
  navigation: ReactNode;
  workspace: ReactNode;
};

export default function InboxShell({
  sidebar,
  navigation,
  workspace,
}: InboxShellProps) {
  return (
    <div className="flex h-full min-h-0 w-full flex-1 overflow-hidden">
      {sidebar}
      <div className="flex min-w-0 flex-1 flex-col">
        {navigation}
        <div className="flex min-h-0 flex-1 items-stretch gap-2 overflow-hidden rounded-[12px] pb-2 pr-2">
          {workspace}
        </div>
      </div>
    </div>
  );
}
